import classnames from 'classnames';
import * as monacoEditor from 'monaco-editor';
import React from 'react';

import { StudioEditorContainer } from 'src/hooks/useStudioEditor';

interface EnvironmentVariablesEditorProps {
  className?: string;
  editor: monacoEditor.editor.IStandaloneCodeEditor;
}
export const EnvironmentVariablesEditor = ({
  className,
  editor,
}: EnvironmentVariablesEditorProps) => {
  return (
    <div
      // Exclude the environment variables from fullstory
      className={classnames('fs-exclude relative overflow-hidden', className)}
    >
      <div className="absolute right-0 top-0 z-20 mr-6 mt-2 px-2 py-1 text-xs uppercase tracking-wider text-secondary">
        JSON
      </div>
      <StudioEditorContainer editor={editor} className="h-full" />
    </div>
  );
};
